import React from "react";
import LeatherbackImg from "../Images/Leatherback-B.jpg";
import Button from "@mui/material/Button";
import Link from "@mui/material/Link";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#99aab5", // custom primary color
    },
    secondary: {
      main: "#F27920", // custom secondary color
    },
  },
});

export default function Leatherback() {
  return (
    <div className="p-5 w-full h-full">
      <div>

        <h2 className="text-2xl font-bold text-[#F27920] pb-5">Leatherback Sea Turtles</h2>

      </div>

      <div className="lg:float-left lg:w-1/3 mb-5 lg:mr-5">
        <img className="rounded-3xl shadow-lg" src={LeatherbackImg} alt="" title="" />
      </div>
      <div>

        The endangered leatherback turtle is the largest and most active of the sea turtles. They
        travel thousands of miles, dive thousands of feet deep, and venture into more colder water
        than any other kind of sea turtle. Up to eight feet in length, these huge turtles have a
        rubbery dark shell marked by seven narrow ridges that extend the length of the back.
        Remarkably, leatherbacks feed on jellyfish and soft-bodied animals that would appear to
        provide very little nutrition for such huge animals. Ingestion of plastic bags and egg
        collecting are reasons for mortality and population declines. About 100 to 200 leatherback
        nests are recorded in Florida each year.

      </div>
      <div className="my-5 text-right">
        <ThemeProvider theme={theme}>
          <Button color="secondary" variant="contained">
            <Link href="/SeaTurtles/Leatherback" title="Leatherback Sea Turtles" style={{ color: '#ffffff' }}>

              More about Leatherback Sea Turtles

            </Link>
          </Button>
        </ThemeProvider>
      </div>
    </div >
  );
}
